import utils from '../utils'
export default {
  /**
    * 输出一个有效地时间戳
    * @type Function
    * @param {Date} 时间戳
    */
  timestamp (timestamp) {
    return utils.timestamp(timestamp)
  },
  /**
   * 日期过滤
   * @type Function
   * @param {Date} 时间戳
   */
  date (timestamp, type, format) {
    return utils.date(timestamp, type, format)
  },
  /**
   * 截取指定长度的字符串
   *
   * 该截取方法区分全半角字符，需要将全角字符的长度 x2
   *
   * @param    {string}  str 要截取的字符串
   * @param    {number}  len 要截取的字符串长度
   * @return   {string}      截取完毕的字符串
   */
  subString (str, len, dot) {
    return utils.subString(str, len, dot)
  }
}
